export enum WrapType {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  NOT_APPLICABLE,
  WRAP,
  UNWRAP,
  APPROVE_AND_WRAP,
  APPROVE_AND_UNWRAP,
}
